'use client';

import React from 'react';

import { TasticProps } from '../types';
import MerchandisingRail from 'components/commercetools-ui/organisms/merchandising-rail';

const MerchandisingRailTastic = ({ data }: TasticProps<any>) => {
  return <MerchandisingRail {...data} />;
};

export default MerchandisingRailTastic;